// Utils
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

// Types
import {
    getActiveMultiProfileIdsLocalStorage,
    getActiveProfileIdLocalStorage
} from '@/utils/localStorage/profilesLocalStorage';
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

function useInitializeMultiProfiles() {
    const {
        updateActiveMultiProfileIds,
        updateActiveSocialProfileId,
        resetActiveMultiSelectionProfiles
    } = useProfilesStore((state) => state);

    // Swr Hooks
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });

    function initializeMultiProfiles() {
        const activeProfileIdLocalStorage = getActiveProfileIdLocalStorage();
        const activeMultiProfileIdsLocalStorage = getActiveMultiProfileIdsLocalStorage();

        if (activeMultiProfileIdsLocalStorage) {
            const activeMultiProfileIds = activeMultiProfileIdsLocalStorage;
            const activatedProfileIds = activatedSocialProfiles?.map((profile) => profile.id);
            const multiProfiles = activatedProfileIds?.filter((profileId) =>
                activeMultiProfileIds.includes(profileId)
            );

            if (multiProfiles?.length === 1) {
                // Update the active profile id in the store if there is only one profile remaining
                resetActiveMultiSelectionProfiles();
                updateActiveSocialProfileId(multiProfiles[0]);
                return { hasInitializedMultiProfiles: true };
            }

            if (multiProfiles?.length > 1) {
                /**
                 * If there is an active profile in the local storage:
                 * Check if the active profile from local storage is still active in the multi profiles
                 */
                if (activeProfileIdLocalStorage) {
                    const activeProfileId = activeProfileIdLocalStorage;
                    if (multiProfiles.find((profileId) => profileId === activeProfileId)) {
                        updateActiveSocialProfileId(activeProfileId);
                    }
                }

                // Use manageProfiles to update the multi profiles in the store + set the active profile
                updateActiveMultiProfileIds(multiProfiles);
                return { hasInitializedMultiProfiles: true };
            }
        }

        return { hasInitializedMultiProfiles: false };
    }
    return { initializeMultiProfiles };
}

export default useInitializeMultiProfiles;
